module.exports = __webpack_public_path__ + "img/logo_login_inferiore.92b864d7.png";